// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__iNCOw","list":"BalanceDue_list__13mxs","listRow":"BalanceDue_listRow__yunhQ","total":"BalanceDue_total__pp3VT"};